import { z } from 'my-zod'
import { DamageWaiverCaseRepairStatusEnum, DamageWaiverCaseDeductibleLevelTypeEnum } from './damage-waiver-case-enums'

export const repairInfoFragment = z
  .object({
    shortId: z.string(),
    deductibleLevel: DamageWaiverCaseDeductibleLevelTypeEnum,
    amountCollected: z.number().min(0).nullable(),
    partsEstimate: z.number().min(0).nullable().setLabel('Parts Estimate (MSRP)'),
    laborHourEstimate: z.number().min(0).nullable(),
    laborCostEstimate: z.number().min(0).nullable(),
    laborHoursApprovedByRisk: z.number().min(0).nullable(),
    laborCompletedBy: z.enum(['Dealer', 'Outfitter']).nullable(),
    dealerId: z.number().nullable().setLabel('Dealer Name'),
    currency: z.enum(['USD', 'CAD']),
    repairStatus: DamageWaiverCaseRepairStatusEnum,
    partsOrderedTotal: z.number().min(0).nullable().setLabel('Parts Ordered Total (Cost)'),
    estimatedTax: z.number().min(0).nullable(),
    miscCost: z.number().min(0).nullable().setLabel('Misc. Cost')
  })
  .setCFV({
    dealerIdRequired(input) {
      if (!input.dealerId && input.laborCompletedBy === 'Dealer') {
        return {
          message: 'Required',
          path: ['dealerId']
        }
      }
    }
  })
